module.exports = __webpack_public_path__ + "img/slider-bg3.64368a44.jpg";